module.exports = __webpack_public_path__ + "img/stitlew.57c6ceea.png";